module.exports = __webpack_public_path__ + "static/img/git_box.b0f8eb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/git_box.png
// module id = LHXf
// module chunks = 1